import React from "react";
import banner6 from "../assets/banner6.jpg"; // replace with actual image path

export default function MonitoringEvaluation() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Monitoring & Evaluation</h2>
        <p className="text-muted small">
          Designing frameworks and systems to track performance and impact.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner6} 
          alt="Monitoring & Evaluation" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group develops monitoring and evaluation frameworks, tools, 
          and systems that enable organisations to track progress and measure impact. 
          We provide capacity-building support for staff, create performance indicators, 
          and design evaluation strategies that inform decision-making. 
          Our services ensure evidence-based management and improve accountability 
          across programmes and projects.
        </p>
      </div>

    </section>
  );
}
